import { createStart, createCsrfMiddleware, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";

// Signed-out visitors to "/" get the static marketing document, decided on the
// server so crawlers receive the real HTML (metadata, OG tags, JSON-LD) in the
// first response. Signed-in visitors fall through to the app's SSR of the
// Gate Manifest, untouched.
const marketingMiddleware = createMiddleware().server(async ({ next, request, pathname, handlerType }) => {
  if (request.method === "GET" && pathname === "/" && handlerType !== "serverFn") {
    const signedIn = (request.headers.get("cookie") ?? "").includes("pd_session=1");
    if (!signedIn) {
      const { MARKETING_HTML } = await import("./lib/marketing.server");
      return new Response(MARKETING_HTML, {
        status: 200,
        headers: {
          "content-type": "text/html; charset=utf-8",
          "cache-control": "public, max-age=0, must-revalidate",
        },
      });
    }
  }
  return next();
});



const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware, marketingMiddleware, csrfMiddleware],
}));
